import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import strings from "../lang/lang";
import prodswitcher from './ProdSwitcherAttention.module.scss';
import cn from 'classnames';
import { useHistory } from 'react-router-dom'

function ProdSwitcherAttention(props) {
    const {isProdSwitcherOpen} = props;

    const [isHome, setIsHome] = useState(false);
    const history = useHistory()

    useEffect(() => {
        return history.listen((location) => {
            if (location.pathname !== '/') {
                setIsHome(false);
            } else {
                setIsHome(true);
            }
        })
    },[history])

    return (
        <>
            {isProdSwitcherOpen && <div className={cn(prodswitcher.prod_switcher__div, {
                [prodswitcher.prod_switcher__hide]: isHome,
        })}>
                <p>
                    {strings.liveMode.text.attention}
                </p>
            </div>}
        </>
    )
}

const mapStateToProps = (state) => ({
    isProdSwitcherOpen: state.prodSwitcher.isProdSwitcherOpen,
});

export default connect(mapStateToProps)(ProdSwitcherAttention);
